import { Button, HorizontalSpacer, Layout, Panel,} from "@mcleod/components";

export abstract class AutogenLayoutRateConfirmationViewer extends Layout {
	buttonDownloadRateConfirmation: Button;
	horizontalspacer2: HorizontalSpacer;
	panelMain: Panel;
	panelRateConView: Panel;
}
